// Same word boundaries as lodash's snakeCase for ASCII input: lower→upper
// ("fetchFormat"), an upper run before a capitalized word ("ABTest"),
// letters↔digits ("x2"), ordinals stay whole ("1st"), and anything that isn't
// a letter or digit separates words. Transformation keys can come from CMS
// content, so this has to match lodash beyond plain camelCase.
const WORDS =
  /[A-Z]+(?=[A-Z][a-z])|[A-Z]?[a-z]+|[A-Z]+|\d*(?:1ST|2ND|3RD|(?![123])\dTH)(?=\b|[a-z_])|\d*(?:1st|2nd|3rd|(?![123])\dth)(?=\b|[A-Z_])|\d+/g;

/**
 * @param {string} value
 * @returns {string} `value` in snake_case, e.g. "fetchFormat" → "fetch_format".
 */
export const snakeCase = (value) =>
  (String(value).match(WORDS) || [])
    .map((word) => word.toLowerCase())
    .join('_');
